export default {
  black: '#000',
  blackTransparent06: 'rgba(0, 0, 0, 0.6)',
  blackTransparent035: 'rgba(0, 0, 0, 0.35)',
  blueColor: '#082c3f',
  blueColorOpacity: 'rgba(8,44,63,.8)',
  blueColorTransparent: 'rgba(8, 44, 63, 0.2)',
  blueDisabled: 'rgba(0, 0, 0, 0.6)',
  blueGrey: '#4c6d7c',
  blueLightGrey: 'rgba(125, 136, 147, 0.5)',
  blueGrey1: '#0b5c75',
  blueGrey2: '#4e5f6d',
  blueLightHover: '#27515E',
  blueShaded: '#083a54',
  dangerRed: '#d31224',
  dangerRedLight: '#FF6363',
  dangerRedTransparent: 'rgba(211,18,36,0.4)',
  coral: '#be5f52',
  vividOrange: '#ff6f00',
  vividOrange2: '#FFAE00',
  darkBlue: '#092c40',
  darkestGrayColor: '#212121',
  mediumDarkGrayColor: '#343434',
  darkGrayColor: '#616161',
  darkGrayHoverColor: 'rgba(97,97,97,0.3)',
  lightGrayColor: 'hsla(0, 0%, 85%, 1)',
  lightGrayTransparentColor: 'hsla(0, 0%, 100%, 0.5)',
  lightGrayHoverColor: 'rgba(230,230,230,0.2)',
  deepblueColor: '#0a354c',
  deepblueColor1: '#093248',
  deepblueColor2: '#072636',
  deepblueColor3: '#061e2d',
  errorRed: '#f44336',
  fluoBlueColor: 'rgba(32,172, 247, 1)',
  fluoBlueColorTransparent: 'rgba(32,172, 247, 0.2)',
  fluoGreenColor: '#74F929',
  fluoOrangeColor: '#FFA020',
  fluoOrangeLightColor: '#FFECC1',
  fluoRedColor: '#EB1F22',
  grayColor: '#bdbdbd',
  labelFontWeight: 300,
  lightBlue: '#16a3b7',
  lightGrey: 'rgba(255, 255, 255, 0.4)',
  lightgreen: '#90ee90',
  lightGreySolid: 'rgb(111, 130, 134)',
  logoColor: '#c5c711',
  mintBorder: '#0c665c',
  mintColor: '#17ecb2',
  mintColorTransparent: 'rgba(23, 236, 178, 0.18)',
  mintColorHoverTransparent: 'rgba(23, 236, 178, 0.1)',
  mintColorSelectedHover: 'rgba(23, 236, 178, 0.26)',
  niceRedColor: '#e11428',
  nicePurpleColor: '#bf4495',
  s2drSnapshotColor: '#AF63FF',
  redColor: '#d31224',
  sourColor: '#E9E9E9',
  transparent: 'rgba(0,0,0,0)',
  vomitColor: 'rgba(198, 195, 13, 1)',
  vomitColorTransparent: 'rgba(198, 195, 13, 0.5)',
  vomitLight: 'rgb(198,195,12)',
  vomitLightFieldSelected: 'rgba(198, 195, 13, 0.9)',
  vomitLightFieldSelectedHover: '#dddd7b',
  vomitLightHover: 'rgba(198, 195, 13, 0.2)',
  vomitLightHoverTransparent: 'rgba(198, 195, 13, 0.1)',
  whiteColor: '#FFFFFF',
  whiteTransparent01: 'rgba(255, 255, 255, 0.1)',
  whiteTransparent015: 'rgba(255, 255, 255, 0.15)',
  whiteTransparent06: 'rgba(255, 255, 255, 0.6)',
  whiteTransparent08: 'rgba(255, 255, 255, 0.8)',
  yellow: 'rgba(255, 252, 42,1)',
  yellowTransparent: 'rgba(255, 252, 42,0.6)',
  customOverlayBackground: 'rgba(0, 0, 0, 0.5)',
  customLightOverlayBackground: 'rgba(0, 0, 0, 0.3)',
  customTooltipBackground: 'rgba(0, 0, 0, 0.9)',
  thumbSwitched: {
    backgroundColor: 'red'
  },
  thumbSwitchos: {
    backgroundColor: 'green'
  },
  deliverables: {
    baseWidth: '270px',
    topWidth: '100%'
  },
  toggle: {
    marginBottom: 0,
    display: 'inline-block',
    width: 'auto',
    height: 16,
    color: '#FFFFFF'
  }
}
